import { Component, AfterViewInit, Input } from '@angular/core';
import { AstrolyticsService } from "../../_services/astrolytics.service";
import * as Chart from "chart.js"

@Component({
  selector: 'app-store-comparation',
  templateUrl: './store-comparation.component.html',
  styleUrls: ['./store-comparation.component.css']
})
export class StoreComparationComponent implements AfterViewInit {

  protected storeData: any = { address: {} }
  protected storeStatistics

  protected loading = true;
  protected error = false;

  @Input() meliId
  @Input() astroId
  private storeId;

  @Input() backgroundColor
  @Input() idSuffix

  protected sellerLevel;
  protected sellerLevelColor;
  protected powerSellerStatus;

  powerSellerTranslations = {
    "silver": "Plata",
    "gold": "Oro",
    "platinum": "Platino"
  }

  constructor(private astrolyticsService: AstrolyticsService) { }

  getStoreData() {

    this.astrolyticsService.getSellerMeliData(this.storeId).subscribe(
      (message) => {
        if (message) {
          this.storeData = message
          this.loading = false;
          setTimeout(() => {
            this.loadInfo();
          });
        }
      },
      (error) => {
        this.loading = false
        this.error = true
      });

    this.astrolyticsService.getSellerStatistics(this.storeId).subscribe(
      (message) => {
        this.storeStatistics = message
      },
      (error) => {
      });
  }

  title = 'angular8chartjs';

  ngAfterViewInit(): void {

    if (this.meliId) {
      this.storeId = this.meliId;
      this.getStoreData();
    } else {
      this.astrolyticsService.getStoreMeliId(this.astroId).subscribe((message) => {
        this.storeId = message
        this.getStoreData();
      },
      (error) => {
        this.loading = false
        this.error = true
      })
    }

  }

  loadInfo() {
    if (this.storeData.seller_reputation.level_id) {
      this.sellerLevel = this.storeData.seller_reputation.level_id.split("_")[0]
      this.sellerLevelColor = this.storeData.seller_reputation.level_id.split("_")[1]
    } else {
      this.sellerLevel = 0
      this.sellerLevelColor = "black"
    }

    if (this.storeData.seller_reputation.power_seller_status) {
      this.powerSellerStatus = this.powerSellerTranslations[this.storeData.seller_reputation.power_seller_status]
    } else {
      this.powerSellerStatus = "No Disponible"
    }

    var transaction_dataset = []
    transaction_dataset.push(this.storeData.seller_reputation.transactions.completed)
    transaction_dataset.push(this.storeData.seller_reputation.transactions.canceled)

    let transaction_canvas: any = document.getElementById(`transaction_graph${this.idSuffix}`)
    let transaction_ctx = transaction_canvas.getContext('2d');
    let transaction_graph = new Chart(transaction_ctx, {
      type: 'bar',
      data: {
        labels: ['Completadas', 'Canceladas'],
        datasets: [{
          label: 'Transacciones',
          data: transaction_dataset,
          backgroundColor: [
            'rgba(75, 192, 192, 1)',
            'rgba(255, 99, 132, 1)'
          ],
          borderColor: [
            'rgba(255, 206, 86, 1)',
            'rgba(255, 99, 132, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });


    var rating_dataset = []
    rating_dataset.push(this.storeData.seller_reputation.transactions.ratings.positive * 100)
    rating_dataset.push(this.storeData.seller_reputation.transactions.ratings.neutral * 100)
    rating_dataset.push(this.storeData.seller_reputation.transactions.ratings.negative * 100)

    let rating_canvas: any = document.getElementById(`rating_graph${this.idSuffix}`)
    let rating_ctx = rating_canvas.getContext('2d');
    let rating_chart = new Chart(rating_ctx, {
      type: 'doughnut',
      data: {
        labels: ['Positivos', 'Neutrales', 'Negativos'],
        datasets: [{
          label: 'Ratings',
          data: rating_dataset,
          backgroundColor: [
            'rgba(75, 192, 192, 1)',
            'rgba(192, 192, 75, 1)',
            'rgba(255, 99, 132, 1)'
          ],
          borderColor: [
            'rgba(206, 206, 86, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(255, 99, 132, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        cutoutPercentage: 30
      }
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.storeData = { address: {} }
  }

}

